import { $rqIotApiClient } from "@/api/iot"

/** A custom query option to fetch all property types, with infinite stale time. */
export const propertyTypesQuery = $rqIotApiClient.queryOptions("get", "/iot/v1/property_types", undefined, {
  staleTime: Infinity
})
